/** Exact recorded cents; never infer payments or currency from a balance. */
function cents(value: string): bigint | null {
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(value)) return null;
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = value.replace(/^-/, '').split('.');
  const amount = BigInt(whole!) * 100n + BigInt(fraction.padEnd(2, '0'));
  return negative ? -amount : amount;
}

export function outstandingPercentage(amount: string, balance: string): number | null {
  const original = cents(amount),
    outstanding = cents(balance);
  if (original === null || outstanding === null || original <= 0n || outstanding < 0n) return null;
  // Preserve cent precision above Number.MAX_SAFE_INTEGER; round only the visual ratio.
  const tenths = (outstanding * 1000n + original / 2n) / original;
  return tenths <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(tenths) / 10 : null;
}

function day(value: string | null): number | null {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const time = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value
    ? time / 86_400_000
    : null;
}

export function invoiceDayInterval(start: string | null, end: string | null): number | null {
  const from = day(start),
    to = day(end);
  return from === null || to === null || to < from ? null : to - from;
}

export function invoiceDisplayDate(value: string | null): string {
  return day(value) === null
    ? 'Not recorded'
    : new Date(`${value}T00:00:00Z`).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
      });
}
